module.exports = __webpack_public_path__ + "static/slide2-d7d6c952f70aa0fbbf9743767ff30dea.png";